/* 🤖 this file was generated by script */
export const wiconArrowNarrowRight = {
  name: 'arrow_narrow_right',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12h16m0 0l-6-6m6 6l-6 6"/></svg>`,
};
